var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:(_vm.column.align?("text-align:" + (_vm.column.align)):'')},[_vm._v(_vm._s(_vm.absence[_vm.column.columnName]))])}
var staticRenderFns = []

export { render, staticRenderFns }